import { createFileRoute } from '@tanstack/react-router'
import QuestionDetail from '@/features/question-lib/question-detail'

export const Route = createFileRoute(
  '/_authenticated/question-lib/$questionLibId/$questionId'
)({
  component: QuestionsLibWrapper,
})

function QuestionsLibWrapper() {
  const { questionId } = Route.useParams() as {
    questionId: string
  }
  return <QuestionDetail key={questionId} />
}
